module.exports = __webpack_public_path__ + "static/media/newspaper-solid.0073ed96.svg";